import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface StartSessionRequestContextType {
  /** When true, Patient Visit should open the audio source dialog (same as "Start Visit"). */
  requestStartSessionFromDashboard: boolean;
  setRequestStartSessionFromDashboard: (v: boolean) => void;
  /** Call after opening the dialog to avoid opening again. */
  clearRequest: () => void;
}

const StartSessionRequestContext = createContext<StartSessionRequestContextType | undefined>(undefined);

export function StartSessionRequestProvider({ children }: { children: ReactNode }) {
  const [requestStartSessionFromDashboard, setRequestStartSessionFromDashboard] = useState(false);

  const clearRequest = useCallback(() => {
    setRequestStartSessionFromDashboard(false);
  }, []);

  return (
    <StartSessionRequestContext.Provider
      value={{
        requestStartSessionFromDashboard,
        setRequestStartSessionFromDashboard,
        clearRequest,
      }}
    >
      {children}
    </StartSessionRequestContext.Provider>
  );
}

export function useStartSessionRequest() {
  const ctx = useContext(StartSessionRequestContext);
  if (ctx === undefined) {
    throw new Error('useStartSessionRequest must be used within StartSessionRequestProvider');
  }
  return ctx;
}
